import Lng from "../3x1010/Lng.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import NavConf from "./components/NavConf.js";
import { getKeyValuePair } from "../helpers/helpers.js";
import ServiceManager from "../3x1010/services/ServiceManager.js";
import DialogNewsletter from "./components/DialogNewsletter.js";
import DialogShare from "./components/DialogShare.js";

export default class PageCommon {
  constructor() {
    this.page = document.body;
  }

  init($data) {
    $(".js-logout").on("click", this.doLogout.bind(this));

    this.setWindowInnerHeight();
    this.initNav();
    this.initVideos();
    this.initDialogNewsletter();
    this.initDialogShare();

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGECOMMON_INITED);
    } catch (error) {
      console.log(error);
    }
  }

  dispatchInitEvent(evenTyepe) {
    // dispaccio un evento globale
    let ev = new Event(evenTyepe);
    ev.payload = { page: this }
    TheDisp.dispatchEvent(ev);
  }

  get isHomepage() {
    return false;
  }

  doLogout() {
    //AuthWiz.doLogout("/");
    ServiceManager.standardCall('/xml/WebService.aspx?action=user.logout', null, (rs) => {
      if (rs.StatusCode == 200) {
        location.href = '/' + TheApp.Locale + '/';
      }
    })
  }

  showPreloader(flag, percent = null) {
    if (flag) {
      if (percent == null) {
        $(".js-percent", $(".js-preloader")).hide();
      } else {
        $(".js-percent", $(".js-preloader")).show();
        $(".js-percent", $(".js-preloader")).text(percent);
      }
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  static showPreloader(flag, percent = null) {
    if (flag) {
      if (percent == null) {
        $(".js-percent", $(".js-preloader")).hide();
      } else {
        $(".js-percent", $(".js-preloader")).show();
        $(".js-percent", $(".js-preloader")).text(percent);
      }
      jQuery(".js-preloader").show();
    } else {
      jQuery(".js-preloader").hide();
    }
  }

  static disable(mc, lFlag, opacity = 0.5) {
    if (lFlag) {
      mc.css("pointer-events", "none");
      mc.css("opacity", opacity);
    } else {
      mc.css("pointer-events", "all");
      mc.css("opacity", 1);
    }
  }

  /**
   * General
   * 
   * set window inner height as variable to <body>,
   * useful if we want to calc the truly available
   * vertical space (without browser bottom nav etc.)
   */
  setWindowInnerHeight() {
    this.page.style.setProperty("--window-h", `${window.innerHeight}px`);

    let resizing;
    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing = setTimeout(() => this.page.style.setProperty(
        "--window-h",
        `${window.innerHeight}px`
      ), 250);
    });
  }

  /**
   * Components
   */
  initNav() {
    const nav = this.page.querySelector(".js-site-header");
    const btn = nav?.querySelector(".js-nav-toggle");
    const btnLabel = btn?(
      getKeyValuePair(
        btn.dataset.closeLabels
      )[nav.dataset.currentLanguage]):null;
    const btnLabelEl = btn?.querySelector(".js-label");
    const clickout = this.page.querySelector(".js-clickout-target");
    const flyout = this.page.querySelector(".js-nav");
    const aside = flyout?.querySelector(".voicelist.aside");
    const btnsOpenSubs = this.page.querySelectorAll(".js-nav .has-sub-menu");
    const voices = this.page.querySelectorAll(".js-nav > .main-voices-wrap > .voicelist:not(.aside) .voice:not(.has-sub-menu)");
    const subMenus = this.page.querySelectorAll(".sub-menu");
    const languageLabel = btn?(
      getKeyValuePair(
        btn.dataset.closeLabels
      )[nav.dataset.currentLanguage]):null;
    const languageLabelEl = nav?.querySelector(".js-language-selector .js-label");

    const navConf = new NavConf(this.page, {
      nav: nav,
      btn: btn,
      btnLabel: btnLabel,
      btnLabelEl: btnLabelEl,
      clickout: clickout,
      flyout: flyout,
      aside: aside,
      btnsOpenSubs: btnsOpenSubs,
      voices: voices,
      subMenus: subMenus,
      languageLabel: languageLabel,
      languageLabelEl: languageLabelEl
    });
    navConf.init();
  }

  initVideos() {
    const videos = this.page.querySelectorAll(".js-video");
    videos?.forEach((el) => {
      const video = el.querySelector("video");
      const btn = el.querySelector(".js-btn-toggle-video");
      let videoPlaying = false;

      video?.addEventListener("loadedmetadata", () => {
        videoPlaying = video.currentTime > 0;

        btn?.addEventListener("click", (e) => {
          if (!videoPlaying) {
            video?.play();
            btn.classList.remove("is-paused");

          } else {
            video?.pause();
            btn.classList.add("is-paused");
          }
          videoPlaying = !videoPlaying;
        });

        if (!videoPlaying) {
          video?.play();
          videoPlaying = true;
        }
      });
      
      //const start = async () => {
      //  video = el.querySelector("video");

      //  return await new Promise(resolve => {
      //    video?.addEventListener("loadedmetadata", () => {
      //      videoPlaying = video?.currentTime > 0;
      //      resolve(videoPlaying);
      //    });
      //  });
      //}      

      //start()
      //  .then(res => {
      //    videoPlaying = res;

      //    const btn = el.querySelector(".js-btn-toggle-video");
      //    btn?.addEventListener("click", (e) => {
      //      if (!videoPlaying) {
      //        video?.play();
      //        btn.classList.remove("is-paused");

      //      } else {
      //        video?.pause();
      //        btn.classList.add("is-paused");
      //      }
      //      videoPlaying = !videoPlaying;
      //    });

      //    if (!videoPlaying) {
      //      video?.play();
      //      videoPlaying = true;
      //    }             
      //  });
    });
  }

  initDialogNewsletter() {
    const form = this.page.querySelector(".js-newsletter-email");
    const dialog = this.page.querySelector(".js-dialog-newsletter");
    const dialogNewsletter = new DialogNewsletter(form, dialog);
    dialogNewsletter.init();
  }

  initDialogShare() {    
    const btn = document.querySelector(".js-btn-share");
    const dialog = document.querySelector(".js-dialog-share");
    const dialogShare = new DialogShare(btn, dialog);    
    dialogShare.init();
  }
}